import React, {useState, useEffect} from 'react';
import { hashCode } from '../../Services/helpers';

const marked = import(/* webpackChunkName: "marked" */'marked');

const Markdown = ({markdown, className, btnCallback, files}) => {
    const [html, setHtml] = useState(null);
    const [hash, setHash] = useState(null);
    const [buttons, setButtons] = useState(null);

    useEffect(() => {
        marked.then(marked => {
            // Convert array options to buttons
            let replaced = markdown.trim().replace(
                /\[((?:"[^"]+",?\s*)+)\]/g,
                (match, options) => {
                    const buttons = JSON.parse(`[${options}]`);
                    setButtons(buttons);
                    return '';
                }
            );
            replaced = marked.parse(replaced);

            // Remove the 【1†a】 type references
            replaced = replaced.replace(
                /【[0-9.:]+†(docs-)?(?<key>[a-zA-Z]+)(\.md)?】/g,
                (match, docs, key) => {
                    if (docs !== 'docs-') {
                        return '';
                    }
                    const path = key.replace(/([A-Z])/g, (m, u) => `-${u.toLowerCase()}`).trim('-');
                    return ` &nbsp; <a href="https://getsoapy.com/docs/${path}">Docs 📄</a>`;
            });

            replaced = replaced.replace(
                /src="\/images\//g,
                'src="https://getsoapy.com/images/'
            );

            // Replace sandbox links with proper upload URLs using files data
            if (files && files.length > 0) {
                replaced = replaced.replace(
                    /sandbox:\/mnt\/data\/([^"\s>)]+)/g,
                    (match, filename) => {
                        const file = files.find(f => f.name === filename);
                        if (file && file.assetId) {
                            const port = parseInt(window.location.port) || 80;
                            const environment = port >= 3000 ? 'local/' : '';
                            return `https://uploads.getsoapy.com/${environment}${file.assetId}/original/${filename}`;
                        }
                        return match;
                    }
                );
            }

            // Ensure all links open in a new tab
            replaced = replaced.replace(
                /a href="/g,
                'a target="_blank" href="'
            );

            setHtml(replaced);
        });
        setHash(hashCode(markdown));
    }, [markdown, files]);

    return <>
        <div className={className}
            dangerouslySetInnerHTML={{__html: html, markdown: hash}}
            markdown={hash}
        />
        {(buttons && btnCallback) && <div className="flex flex-wrap gap-2 justify-center mt-2">
            {buttons.map(button => {
                return <button className="btn btn-sm surface-1 px-3"
                    onClick={() => btnCallback(button)}
                >
                    {button}
                </button>
            })}
        </div>}
    </>;
}

export default Markdown;
